<template>
  <div
    :class="$style.titleContainer"
  >
    <a
      href="#"
      :class="['btn btn-primary', $style.btnBack]"
      @click.prevent="onClick"
    ></a>

    <h1 class="h3 d-inline-block ml-3 mb-0 align-middle">
      <slot name="title"></slot>
    </h1>

    <slot></slot>
  </div>
</template>

<script>
export default {
  methods: {
    onClick () {
      this.$router.go(-1)
    }
  }
}
</script>

/// #if PLATFORM !== 'xd'
<style lang="scss" module>
.titleContainer {
  h1, span {
    line-height: 24px;
  }

  .btnBack {
    width: 24px;
    height: 24px;
    padding: 8px;
    line-height: 8px;
    @include caret('left');
  }
}
</style>
/// #endif
